import {
  Box,
  Divider,
  DrawerHeader,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  useBreakpointValue,
} from '@chakra-ui/react';
import { useChangePlanModalContext } from '../ModalContext';

const ChangePlanModalHeader = () => {
  const { step, contract, loading, setStep } = useChangePlanModalContext();

  const orientation = useBreakpointValue({
    base: 'vertical',
    sm: contract ? 'horizontal' : 'vertical',
    md: 'horizontal',
  }) as 'vertical' | 'horizontal';

  const onClickPlan = () => !loading && setStep(0);

  return (
    <DrawerHeader>
      Trocar plano
      <Divider my="1rem" />
      <Stepper index={step} mt="1.5rem" orientation={orientation}>
        <Step>
          <StepIndicator
            cursor={step > 0 ? 'pointer' : 'default'}
            onClick={onClickPlan}
          >
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>

          <Box
            flexShrink="0"
            cursor={step > 0 ? 'pointer' : 'default'}
            onClick={onClickPlan}
          >
            <StepTitle>Plano</StepTitle>
          </Box>
          <StepSeparator />
        </Step>

        <Step>
          <StepIndicator>
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>

          <Box flexShrink="0">
            <StepTitle>Resumo</StepTitle>
          </Box>
          <StepSeparator />
        </Step>
      </Stepper>
    </DrawerHeader>
  );
};

export default ChangePlanModalHeader;
